import Page from '@classes/Page';

export default class About extends Page {
  constructor() {
    super({
      element: '.about',
      elements: {
        wrapper: '.about__wrapper',
      },
    });
  }
}